(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[544],{

/***/ 6117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore",
      function () {
        return __webpack_require__(5396);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);


var PageTitle = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__.clsx)("text-2xl xl:text-4xl font-bold mb-5 md:mb-8", className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 3393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ skeletonLoader_SkeletonLoader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs


/**
 * @internal
 */
const SkeletonThemeContext = react.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react.createElement(react.Fragment, { key: i },
                skeletonSpan,
                react.createElement("br", null)));
        }
    }
    return (react.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}



// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(4714);
;// CONCATENATED MODULE: ./src/components/ui/skeletonLoader/SkeletonLoader.tsx






var SkeletonLoader = function(_param) {
    var className = _param.className, rest = _objectWithoutProperties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        baseColor: "#47536a",
        highlightColor: "#69718d",
        className: className ? "rounded-xl ${className}" : "rounded-xl"
    }));
};
/* harmony default export */ var skeletonLoader_SkeletonLoader = (SkeletonLoader);


/***/ }),

/***/ 5396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ explore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/ui/pageTitle/PageTitle.tsx
var PageTitle = __webpack_require__(1269);
// EXTERNAL MODULE: ./src/components/ui/skeletonLoader/SkeletonLoader.tsx + 3 modules
var SkeletonLoader = __webpack_require__(3393);
// EXTERNAL MODULE: ./src/services/crypto/cryptoService.ts
var cryptoService = __webpack_require__(2395);
;// CONCATENATED MODULE: ./src/components/screens/explore/Explore.tsx






var Explore = function() {
    var ref = (0,react.useState)(9), listLength = ref[0], setListLength = ref[1];
    var ref1 = (0,cryptoService/* useCryptoNewsQuery */.t1)(""), data = ref1.data, isLoading = ref1.isLoading, error = ref1.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                children: "Latest crypto news"
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-11 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                        height: 580
                    })
                ]
            }),
            data && !error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "grid gap-11 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
                        children: data.slice(0, listLength).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "p-4 card-block block h-full transition-transform hover:-translate-y-2 will-change-transform",
                                    href: item.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                width: 300,
                                                height: 300,
                                                objectFit: "cover",
                                                src: item.imgUrl,
                                                alt: item.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm mb-2 opacity-80",
                                            children: item.date
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm mb-4 opacity-80",
                                            children: item.categories
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-2xl font-bold mb-4",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item.body.length > 160 ? "".concat(item.body.slice(0, 160), "...") : item.body
                                        })
                                    ]
                                })
                            }, item.id);
                        })
                    }),
                    data.length > listLength && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mt-8 text-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn min-w-[300px] p-5",
                            onClick: function() {
                                return setListLength(function(prevValue) {
                                    return prevValue + 6;
                                });
                            },
                            children: "Load more"
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-2xl text-red-500",
                children: "Something went wrong. Please try again later."
            })
        ]
    });
};
/* harmony default export */ var explore_Explore = (Explore);

// EXTERNAL MODULE: ./src/providers/meta/Meta.tsx
var Meta = __webpack_require__(8222);
;// CONCATENATED MODULE: ./src/pages/explore.tsx



var ExplorePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
        title: "Explore",
        description: "Explore crypto-news",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(explore_Explore, {})
    });
};
/* harmony default export */ var explore = (ExplorePage);


/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3293);




var Meta = function(param) {
    var title = param.title, description = param.description, _image = param.image, image = _image === void 0 ? null : _image, children = param.children;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().asPath;
    var currentUrl = "".concat("https://crypto-pet-front-88oi.vercel.app").concat(asPath);
    var siteName = "Crypto notebook";
    var ogLogo = "".concat("https://crypto-pet-front-88oi.vercel.app", "/static/images/og-logo.jpg");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        itemProp: "headline",
                        children: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        itemProp: "description",
                        name: "description",
                        content: (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .onlyText */ .RJ)(description, 152)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: currentUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: currentUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image || ogLogo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: siteName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .onlyText */ .RJ)(description, 197)
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            children
        ]
    });
};


/***/ }),

/***/ 4714:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);